module.exports = __webpack_public_path__ + "img/bg.f20a2c82.jpg";